import { CONFIG } from 'app/core/config';
import { ViewModel } from '../view-model';
import { EventTemplateAttribute } from './event-template-attribute';
import { Process } from './process';

export class EventTemplate implements ViewModel {
  readonly friendlyTypeNameSingular = 'Event Template';
  readonly apiRoute: string = CONFIG.apiRoutes.eventTemplate;

  id: string;
  name: string;
  description: string;
  processId: string;
  process: Process;
  attributes: EventTemplateAttribute[] = [];

  json(): any {
    return this;
  }

  loadFromJson(data: any): void {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;

    this.processId = data.processId;
    if (data.process) {
      this.process = new Process();
      this.process.loadFromJson(data.process);
    }

    if (data.attributes) {
      data.attributes.forEach(attribute => {
        const newAttribute = new EventTemplateAttribute();
        newAttribute.loadFromJson(attribute);
        this.attributes.push(newAttribute);
      });
    }
  }
}
